import { Link, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { BookOpen, Mail, LogOut, Users, UserPlus, Image as ImageIcon } from "lucide-react";
import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import { useToast } from "./ui/use-toast";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin/login");
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to sign out. Please try again.",
      });
    }
  };

  const menuItems = [
    { path: "/admin/blogs", label: "Blogs", icon: BookOpen },
    { path: "/admin/newsletters", label: "Newsletters", icon: Mail },
    { path: "/admin/subscribers", label: "Subscribers", icon: UserPlus },
    { path: "/admin/contacts", label: "Contacts", icon: Users },
    { path: "/admin/media", label: "Media Library", icon: ImageIcon },
  ];

  return (
    <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-forest-green/10">
      <div className="flex h-full flex-col">
        {/* Header */}
        <div className="flex h-16 items-center border-b border-forest-green/10 px-6">
          <Link to="/admin" className="flex items-center gap-2">
            <img
              src="/cittasya-logo.svg"
              alt="Cittasya®"
              className="h-8 w-auto"
            />
            <span className="font-heading text-lg text-forest-green">
              Admin
            </span>
          </Link>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 px-3 py-4">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-forest-green text-white"
                    : "text-forest-green hover:bg-forest-green/5"
                )}
              >
                <Icon
                  className={cn(
                    "h-5 w-5 transition-colors",
                    isActive
                      ? "text-white"
                      : "text-forest-green/60 group-hover:text-forest-green"
                  )}
                />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="border-t border-forest-green/10 p-3">
          <Button
            variant="ghost"
            className="w-full justify-start gap-2 text-forest-green hover:bg-forest-green/5 hover:text-forest-green"
            onClick={handleLogout}
          >
            <LogOut className="h-5 w-5" />
            <span>Logout</span>
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
